"use client";

import { useAuth } from "@/app/lib/auth";
import Link from "next/link";
import Image from "next/image";
import { LoginButton } from "./auth-buttons";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User, LogOut } from "lucide-react";

export function UserMenu() {
  const { isAuthenticated, user, logout } = useAuth();

  if (!isAuthenticated || !user) {
    return <LoginButton />;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 px-2 py-1 rounded-md hover:bg-muted transition-colors">
        {user.picture ? (
          <div className="relative w-8 h-8 rounded-full overflow-hidden">
            <Image
              src={user.picture}
              alt={user.name || "User"}
              fill
              sizes="32px"
              className="object-cover"
            />
          </div>
        ) : (
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
            <User size={16} className="text-primary" />
          </div>
        )}
        <span className="hidden md:inline">{user.name || "User"}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="user-menu-fix">
        <style jsx global>{`
          /* Only apply in light mode */
          :root:not(.dark) .user-menu-fix [role="menuitem"]:hover {
            color: #000000 !important;
            background-color: rgba(220, 220, 220, 0.5) !important;
          }
          /* Ensure dark mode uses white text */
          :root.dark .user-menu-fix [role="menuitem"]:hover {
            color: #ffffff !important;
            background-color: rgba(50, 50, 50, 0.8) !important;
          }
          /* Special handling for logout button */
          .user-menu-fix [role="menuitem"].text-destructive:hover {
            color: #ffffff !important;
            background-color: rgba(220, 38, 38, 0.9) !important;
          }
        `}</style>
        <DropdownMenuItem asChild>
          <Link href="/profile" className="w-full">
            Profile
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={logout}
          className="text-destructive font-medium"
        >
          <LogOut size={16} className="mr-2" />
          <span>Logout</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
